import React, { useEffect, useState, useRef } from 'react';

import styles from './our-values.module.scss';

import smorgaImageUrls from './images-url';

const OurValuesImageCarousel = () => {
  const delay = 6000;
  const [position, setPosition] = useState(0);
  const intervalId = useRef(null);

  useEffect(() => {
    intervalId.current = setInterval(
      () =>
        setPosition((prevPosition) =>
          prevPosition === smorgaImageUrls.length - 1 ? 0 : prevPosition + 1
        ),
      delay
    );
    return () => {
      clearInterval(intervalId.current);
    };
  }, []);

  return (
    <div className={styles.valuesSmorgaCarouselOuter}>
      <div
        className={styles.valuesSmorgaCarouselInner}
        style={{ transform: `translate3d(${-position * 100}%, 0, 0)` }}
      >
        {smorgaImageUrls.map((smorgaImageUrl) => (
          <div
            key={smorgaImageUrl}
            className={styles.valuesSmorgaDesktopImage}
            style={{ backgroundImage: `url(${smorgaImageUrl})` }}
          />
        ))}
      </div>
    </div>
  );
};

export default OurValuesImageCarousel;
